import api from '../../../config/axios'
import type { Sensor } from '../../../types'
import type { CreateSensorRequest, UpdateSensorRequest } from '../../../types/api'
import { API } from '../../../config/links';

export interface SensorResponse {
  data: Sensor[]
  total: number
  page: number
  limit: number
}

export interface SensorFilters {
  sensor_type_category?: string;
  sensor_type_type?: string;
  sensor_type_model?: string;
  sensor_type_measurement_range?: number;
  sensor_type_family?: string;
  created_by?: string;
  created_date_from?: string;
  created_date_to?: string;
}

export const SensorService = {
  getSensors: (page = 1, limit = 100, include?: string, filters?: SensorFilters) => 
    api.get<SensorResponse>(API.sensors.list, {
      params: {
        page,
        limit,
        include: include || 'calibrations',
        ...(filters?.sensor_type_category && { sensor_type_category: filters.sensor_type_category }),
        ...(filters?.sensor_type_type && { sensor_type_type: filters.sensor_type_type }),
        ...(filters?.sensor_type_model && { sensor_type_model: filters.sensor_type_model }),
        ...(filters?.sensor_type_measurement_range !== undefined && { sensor_type_measurement_range: filters.sensor_type_measurement_range }),
        ...(filters?.sensor_type_family && { sensor_type_family: filters.sensor_type_family }),
        ...(filters?.created_by && { created_by: filters.created_by }),
        ...(filters?.created_date_from && { created_date_from: filters.created_date_from }),
        ...(filters?.created_date_to && { created_date_to: filters.created_date_to }),
      },
    }).then(res => res.data),

  getSensorById: (id: string, include?: string) => 
    api.get<Sensor>(API.sensors.byId(id), {
      params: {
        ...(include && { include }),
      },
    }).then(res => res.data),

  createSensor: (data: CreateSensorRequest) => 
    api.post<Sensor>(API.sensors.list, data).then(res => res.data),

  updateSensor: (id: string, data: UpdateSensorRequest) => 
    api.put<Sensor>(API.sensors.byId(id), data).then(res => res.data),

  deleteSensor: (id: string) => 
    api.delete(API.sensors.byId(id)),

  searchSensorBySerialNumber: (serialNumber: string, include?: string) => 
    api.get<Sensor>(API.sensors.search, {
      params: {
        serial_number: serialNumber,
        ...(include && { include }),
      },
    }).then(res => res.data),
}